import { mount } from 'svelte';
import VideoPopup from './VideoPopup.svelte';

const trigger = document.querySelectorAll('.js-hero-video-trigger');

export const videoPopup = () => {
  trigger.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      mount(VideoPopup, {
        target: document.body,
      });
    });
  });
};
